let ctx = null;

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
}

export function primeChime() {
  const c = getCtx();
  if (c && c.state === "suspended") void c.resume();
}

// Browsers only allow sound after a tap, so warm the audio up on the first interaction.
function prime() {
  primeChime();
  window.removeEventListener("pointerdown", prime);
  window.removeEventListener("keydown", prime);
}
if (typeof window !== "undefined") {
  window.addEventListener("pointerdown", prime);
  window.addEventListener("keydown", prime);
}

const PARTIALS = [[1, 1], [2, 0.5], [2.76, 0.32], [5.4, 0.14], [8.93, 0.06]];

function bell(c, out, freq, at, length) {
  PARTIALS.forEach(([ratio, amp]) => {
    const osc = c.createOscillator();
    const g = c.createGain();
    osc.type = "sine";
    osc.frequency.value = freq * ratio;
    const dur = length / (1 + ratio * 0.35);
    g.gain.setValueAtTime(0, at);
    g.gain.linearRampToValueAtTime(amp, at + 0.008);
    g.gain.exponentialRampToValueAtTime(0.0001, at + dur);
    osc.connect(g).connect(out);
    osc.start(at);
    osc.stop(at + dur + 0.05);
  });
}

let lastPlayed = 0;


export async function playMidnightChime() {
  const c = getCtx();
  if (!c) return false;
  if (Date.now() - lastPlayed < 2000) return true;
  if (c.state === "suspended") {
    try { await Promise.race([c.resume(), new Promise((r) => setTimeout(r, 300))]); } catch { /* needs a tap first */ }
  }
  if (c.state !== "running") {
    const requested = Date.now();
    const onTap = () => {
      window.removeEventListener("pointerdown", onTap);
      if (Date.now() - requested < 8000) void c.resume().then(() => playMidnightChime());
    };
    window.addEventListener("pointerdown", onTap);
    return false;
  }
  lastPlayed = Date.now();
  const master = c.createGain();
  master.gain.value = 0.11;
  const lp = c.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 5200;
  master.connect(lp).connect(c.destination);
  const t = c.currentTime + 0.05;
  [[1318.5, 0], [987.8, 0.42], [1661.2, 0.84], [1318.5, 1.5]].forEach(([f, d], i) => bell(c, master, f, t + d, i === 3 ? 4.2 : 2.8));
  return true;
}
